<ng-container *ngIf="message">

  <div class="message-container"
       [ngStyle]="{'justify-content' : (message.user.id | plus) === (scId | plus) && message.type !== 'JOIN' && !chatsService.userAdmin ? 'flex-end' : message.type === 'JOIN' ? 'center' : 'flex-start'}">

    <ng-template *ngIf="messageState && messageState.messageCheckboxOn; then checkbox"></ng-template>

    <div [ngClass]="{user : (message.user.id | plus) === (scId | plus) && message.type !== 'JOIN' && !chatsService.userAdmin,
    'join-message' : message.type === 'JOIN'}"
         class="message"
         (contextmenu)="onRightClick($event)"
         #messageElement>

      <ng-template *ngIf="message.type === 'JOIN'; then joinUser"></ng-template>

      <span
        *ngIf="message.user && message.user.firstName && (message.user.id | plus) !== (scId | plus) || message.type === 'JOIN' || chatsService.userAdmin"
        class="first-name">{{message.user.firstName}} {{message.user.lastName}}</span>

      <ng-template *ngIf="message.replyMessage; then replyMessage"></ng-template>

      <ng-template
        *ngIf="message.type && fileFormats.indexOf(message.type) >= 0 && message.status === 'notLoaded'; then messageFile"></ng-template>

      <ng-template
        *ngIf="message.type && fileFormats.indexOf(message.type) >= 0 && message.status !== 'notLoaded'; then fileTemplate"></ng-template>

      <span *ngIf="message.messageContent && message.messageContent.text && fileFormats.indexOf(message.type) < 0"
        class="message-content"
        [innerHTML]="replaceOID(message.messageContent.text, message.mentionedUsers) | linkify"></span>
      
      <span *ngIf="message.type === 'REMOVED_BY_MODERATOR'" class="message-content">
        Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÐ´Ð°Ð»ÐµÐ½Ð¾ Ð¼Ð¾Ð´ÐµÑÐ°ÑÐ¾ÑÐ¾Ð¼
      </span>

      <div
        *ngIf="message.type === 'POLL' && message.messageContent && message.messageContent.question && message.messageContent.answers"
        class="poll-content">

        <b>ÐÐ¿ÑÐ¾Ñ</b>
        <span>{{message.messageContent.question | messageContent}}</span>

        <b>ÐÐ°ÑÐ¸Ð°Ð½ÑÑ Ð¾ÑÐ²ÐµÑÐ°</b>
        <div *ngFor="let answer of message.messageContent.answers; trackBy: trackByFn;"
             (click)="toVote(answer)"
             class="answers">

          <span>{{answer.title}} {{answer.voteCount > 0 ? '&middot; ' + answer.voteCount : ''}}</span>

          <div *ngIf="message.messageContent.voteAnswerId >= 0"
               class="vote-result"
               [ngStyle]="{'width' : answer.voteCount ? answer.voteCount / votersNumber() * 100 + '%' : '0',
               'background-color' : popularAnswerId === answer.id ? '#4D83FA' : '#E5EAF5'}">
          </div>

        </div>

        <span class="voters-number">ÐÑÐ¾Ð³Ð¾Ð»Ð¾ÑÐ¾Ð²Ð°Ð»Ð¾ {{votersNumber()}}</span>
      </div>

      <div class="status">

        <ng-template
          *ngIf="!chatsService.userAdmin && message.status === 'unsent' && fileFormats.indexOf(message.type) < 0; then unsent"></ng-template>
        <ng-template
          *ngIf="!chatsService.userAdmin && (message.status === 'sent' || !message.status) && message.type !== 'JOIN' && (message.user.id | plus) === (scId | plus); then sent"></ng-template>

        <span
          *ngIf="message.dateTime && (fileFormats.indexOf(message.type) < 0 || fileFormats.indexOf(message.type) >= 0 && message.status !== 'notLoaded')"
          class="date-time">
          {{message.dateTime | messageDate }}
        </span>

      </div>

      <ng-template *ngIf="showMenu && ((message.user.id | plus) !== (scId | plus) || chatsService.userAdmin) && message.type !== 'JOIN'; then menu"></ng-template>
      <ng-template *ngIf="showMenu && (message.user.id | plus) === (scId | plus) && !chatsService.userAdmin && message.type !== 'JOIN'; then userMenu"></ng-template>

      <div *ngIf="message.withComplaint" (click)="goToOperateComplaint(message.withComplaint.id)" [class.symLeft]="(message.user.id | plus) === (scId | plus) && message.type !== 'JOIN' && !chatsService.userAdmin ? true : false" class="complaintInChat">
        <div class="complaintInChat__sym">
          !
        </div>
      </div>
      
    </div>

  </div>

</ng-container>

<ng-template #menu>
  <ul *ngIf="showMenu && ((message.user.id | plus) !== (scId | plus) || chatsService.userAdmin)"
      [ngClass]="{'menu-bottom-position': menuBottomPosition}"
      class="menu scroll-hidden">
    <li *ngIf="!chatsService.userAdmin" (click)="setMessageAction('replyMessage')">ÐÑÐ²ÐµÑÐ¸ÑÑ</li>
    <li *ngIf="!chatsService.userAdmin" (click)="messageCheckboxOn()">ÐÑÐ´ÐµÐ»Ð¸ÑÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾</li>
    <li *ngIf="message.type && fileFormats.indexOf(message.type) < 0 && chatsService.userAdmin"
        (click)="setMessageAction('deleteMessage')">Ð£Ð´Ð°Ð»Ð¸ÑÑ
    </li>
  </ul>
</ng-template>

<ng-template #userMenu>
  <ul class="menu user-menu scroll-hidden" [ngClass]="{'menu-bottom-position': menuBottomPosition}">

    <li *ngIf="message.status !== 'unsent'"
        (click)="setMessageAction('replyMessage')">ÐÑÐ²ÐµÑÐ¸ÑÑ
    </li>

    <li *ngIf="message.status !== 'unsent'"
        (click)="messageCheckboxOn()">ÐÑÐ´ÐµÐ»Ð¸ÑÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾
    </li>

    <li *ngIf="message.status === 'unsent'"
        (click)="setMessageAction('sendMessage')">ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ
    </li>

    <li *ngIf="message.type && fileFormats.indexOf(message.type) < 0 && message.type !== 'POLL'"
        (click)="setMessageAction('editMessage')">Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ
    </li>

    <li (click)="setMessageAction('deleteMessage')">Ð£Ð´Ð°Ð»Ð¸ÑÑ Ñ Ð²ÑÐµÑ</li>
  </ul>
</ng-template>

<ng-template #checkbox>
  <lib-checkbox
    (change)="checkBoxChange()"
    [(ngModel)]="checkBoxValue">
  </lib-checkbox>
</ng-template>

<ng-template #unsent>
  <span class="unsent">!</span>
</ng-template>

<ng-template #sent>
  <!-- <img src="assets/img/chat/read.svg" alt="read"/> -->
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8243 5.17948C18.59 4.94017 18.2101 4.94017 17.9757 5.17948L10.7874 12.5208L9.84951 11.5C9.6152 11.2607 9.23533 11.2607 9.00098 11.5C8.76665 11.7393 8.76665 12.1272 9.00098 12.3666L10.3631 13.8206C10.5974 14.0599 10.9775 14.0597 11.2117 13.8206L18.8243 6.04606C19.0586 5.80677 19.0586 5.4188 18.8243 5.17948Z"
      fill="#1D5DEB" />
    <path
      d="M13.839 5.17948C13.6044 4.94017 13.224 4.94017 12.9894 5.17948L5.79207 12.5208L3.02555 9.69895C2.79095 9.45964 2.41061 9.45966 2.17596 9.69895C1.94135 9.93824 1.94135 10.3262 2.17596 10.5655L5.36728 13.8206C5.60181 14.0599 5.98244 14.0597 6.21687 13.8206L13.839 6.04606C14.0736 5.80677 14.0736 5.4188 13.839 5.17948Z"
      fill="#1D5DEB" />
  </svg>
</ng-template>

<ng-template #replyMessage>
  <div class="reply-message">
    <span
      *ngIf="message.replyMessage.type !== 'POLL'">{{message.replyMessage.user.firstName}} {{message.replyMessage.user.lastName}}</span>
    <span *ngIf="message.replyMessage.type === 'POLL'">ÐÐ¿ÑÐ¾Ñ</span>
    <span class="reply-message-content"
          *ngIf="message.replyMessage.messageContent">&nbsp;{{cropText(message.replyMessage.messageContent.text || message.replyMessage.messageContent.question | messageContent)}}</span>
  </div>
</ng-template>

<ng-template #messageFile>
  <div class="file-upload">
    <arm-file [filesInfo]="[message]" [fileSubscribe]="fileSubscribe"></arm-file>
  </div>
</ng-template>

<ng-template #fileTemplate>
  <arm-download [message]="message"></arm-download>
</ng-template>

<ng-template #joinUser>
  <div class="join-message">
    <span class="join-title">ÐÐ¾Ð²ÑÐ¹ ÑÑÐ°ÑÑÐ½Ð¸Ðº ÑÐ°ÑÐ°</span>
  </div>
</ng-template>
